// extracted by mini-css-extract-plugin
export default {"container":"HfpnHnxYV8FBYNv5vB6w"};